export default __webpack_public_path__ + "static/media/landing-triatlon.dd772808.jpg";